module.exports = __webpack_public_path__ + "static/media/27OCHA5.70fb3cba.jpg";